import { connect } from 'react-redux'
import DealCompare from 'pages/mwdealcompare/Main'

const mapStateToProps = state => ({
  isLogged: state.user.isLogged,
  isLimitedAccess: state.user.isLimitedAccess
})

export default connect(mapStateToProps)(DealCompare)
